import React from 'react'
import OperacionesAsignacion from '../containers/asignacionCupos/OperacionesAsignacion'

// Atención: Cuidado al cambiar el orden de las columnas porque se utilizan
// los valores de tableMeta.rowData para eliminar de la tabla.
export const COLUMNS_CUPOS_PARA_ASIGNAR = [
  {
    name: 'fechaDeEmision',
    label: 'Fecha de Cupo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'tipoCupo',
    label: 'Tipo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cantidadAsignada',
    label: 'Asignados',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'exportador',
    label: 'Acciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        return <OperacionesAsignacion id={value} tableMeta={tableMeta} updateValue={updateValue} />
      }
    }
  }
]

export const COLUMNS_CUPOS_PARA_ASIGNAR_TO_PRINT = [
  {}
]
